import React from 'react';
import { isObject, escapeRegExp, isEqual } from 'lodash';

var textHelpers = require('./text-helpers');

var Box = React.createClass({

  propTypes: {
    value: React.PropTypes.oneOfType([
      React.PropTypes.string,
      React.PropTypes.number,
      React.PropTypes.object
    ]),
    isOpened: React.PropTypes.bool
  },

  getDefaultProps(){
    return {
      text: "",
      isOpened: false
    };
  },

  render(){
    var {value, isOpened, onClick} = this.props;
    var arrowClass = {
      "fa": true,
      "fa-angle-down": !isOpened,
      "fa-angle-up": !!isOpened
    };

    return (
      <div className="selected" onClick={onClick}>
                <span>
                    <span
                      className="selected-text"> {this._getText(value)} </span>
                </span>
        <a className="ui-button">
          <i className={classnames(arrowClass)}/>
        </a>
      </div>
    )
  },

  _getText(value){
    return isObject(value)
      ? (value.label || null)
      : (value || null);
  }
});

var Dropdown = React.createClass({

  propTypes: {
    isOpened: React.PropTypes.bool,
    placeholder: React.PropTypes.string,
    options: React.PropTypes.array,
    value: React.PropTypes.oneOfType([
      React.PropTypes.string,
      React.PropTypes.number,
      React.PropTypes.object
    ]),

    onSelect: React.PropTypes.func,
    onAddItem: React.PropTypes.func,
    maxlength: React.PropTypes.number,
    searchFieldValidationHandler: React.PropTypes.func,
    searchFieldValidationMessage: React.PropTypes.string
  },

  getDefaultProps(){
    return {
      isOpened: false,
      options: [],
      maxlength: 0
    };
  },

  getInitialState(){
    return {
      filter: "",
      isSearchFieldInvalid: false
    }
  },

  componentWillReceiveProps(nextProps){
    if (nextProps.isOpened != this.props.isOpened) {
      this.setState({
        filter: "",
        isSearchFieldInvalid: false
      });
    }
  },

  render(){
    var {isOpened} = this.props;
    if (!isOpened) return null;

    return (
      <div className="dropdown-box">
        {this._getInput()}
        {this._getList()}
      </div>
    )
  },

  getSearchValue() {
    return this.state.filter;
  },

  _getInput(){
    const { placeholder, searchFieldValidationMessage } = this.props;
    const { isSearchFieldInvalid } = this.state;

    return (
      <div className="inputbox">
        <input
          ref="Input"
          type="text"
          placeholder={placeholder}
          onChange={this._filterOptions}
          onKeyPress={this._handleKeyPress}
          value={this.state.filter}
        />
        <span
          display-if={isSearchFieldInvalid}
          className="esk-error-label"
        >
          {searchFieldValidationMessage}
        </span>
      </div>
    )
  },

  _getList(){
    var {options} = this.props;
    return (
      <ul>
        {this._addNewItemField()}
        {options.filter(this._filterItems).map(this._getListItem)}
      </ul>
    );
  },

  _filterItems(item){
    var {filter} = this.state;

    if (!filter) return item;

    var filterRegexp = new RegExp("^" + escapeRegExp(filter), "i");

    var value = isObject(item)
      ? item.label
      : item;

    if (!value) return null;

    return filterRegexp.test(value) ? value : null;
  },

  _getListItem(item, index){
    var self = this;

    if (isObject(item)) {
      var {value, label} = item;
    } else {
      value = label = item;
    }

    return (<DropdownItem
        key={index}
        onClick={this.props.onSelect.bind(null, item)}
        isSelected={this._isSelectedValue(item)}
      >
        {textHelpers.highlightText(label, this.state.filter)}
      </DropdownItem>
    );
  },

  _addNewItemField(){

    var value = this._getInputValue();

    if (!value) {
      return null;
    }

    var isCurrent = !!this._getValueFromList(value);

    if (isCurrent) return null;

    return (<DropdownItem
        key="add-item"
        onClick={() => { this.handleAddNewDropdownItem(value); }}>
        {i18n.t("Add \"%s\"", {
          context: 'UI',
          ns: 'main',
          postProcess: 'sprintf',
          sprintf: [value]
        })}
      </DropdownItem>
    );
  },

  handleAddNewDropdownItem(value) {
    const { searchFieldValidationHandler } = this.props;

    if (searchFieldValidationHandler) {
      const isValid = searchFieldValidationHandler(value);
      this.setState({ isSearchFieldInvalid: !isValid });
      if (!isValid) return;
    }

    this.props.onAddItem(this._getNewItemObject(value));
  },

  _getNewItemObject(label){
    return {label: label, value: Select.defaultValue};
  },

  _getInputValue(){
    return this.refs.Input ? this.refs.Input.value : null;
  },

  _getValueFromList(value){
    var {options} = this.props;
    var searchRegexp = new RegExp("^" + escapeRegExp(value) + "$", "i");
    return options.find((item) => (
      searchRegexp.test(isObject(item) ? item.label : item)
    ));
  },

  _isSelectedValue(item){
    return isEqual(this.props.value, item);
  },

  _filterOptions(){
    const value = this._getInputValue();

    let isSearchFieldInvalid;
    if (!value) {
      isSearchFieldInvalid = false;
    } else {
      isSearchFieldInvalid = this.state.isSearchFieldInvalid;
    }

    this.setState({
      filter: value ? value : "",
      isSearchFieldInvalid
    });
  },

  _handleKeyPress(e){
    if (e.key !== 'Enter') {
      var {maxlength} = this.props;
      var inputValue = e.target.value;
      this.setState({
        filter: maxlength ? inputValue.substr(0, maxlength) : inputValue
      });
      return true;
    }

    e.stopPropagation();
    e.preventDefault();

    var value = this._getInputValue();

    if (!value) {
      return false;
    }

    var listValue = this._getValueFromList(value);

    if (listValue) {
      this.props.onSelect(listValue);
    } else {
      this.handleAddNewDropdownItem(value);
    }

    return false;
  }

});

var DropdownItem = React.createClass({

  propTypes: {
    isSelected: React.PropTypes.bool,
    filter: React.PropTypes.string
  },

  getInitialState(){
    return {
      isOver: false
    }
  },

  render(){
    var self = this;
    var {isSelected, onClick, filter, text} = this.props;

    var itemClass = {
      "selected": !!isSelected,
      "over": self.state.isOver
    };

    return (
      <li
        onClick={onClick}
        onMouseEnter={this._setHover}
        onMouseLeave={this._removeHover}
        className={classnames(itemClass)}>
        {this.props.children}
      </li>
    );
  },

  _setHover(){
    this.setState({isOver: true});
  },

  _removeHover(){
    this.setState({isOver: false});
  }

});

var Select = React.createClass({

  statics: {
    labelField: "label",
    valueField: "value",
    defaultValue: -1
  },

  propTypes: {
    options: React.PropTypes.array.isRequired,
    name: React.PropTypes.string,
    placeholder: React.PropTypes.string,
    defaultValue: React.PropTypes.object,
    maxlength: React.PropTypes.number,
    onSelect: React.PropTypes.func,
    searchFieldValidationHandler: React.PropTypes.func,
    searchFieldValidationMessage: React.PropTypes.string
  },

  dropdown: null,

  getInitialState(){
    var {options, defaultValue} = this.props;
    return {
      options: options,
      isOpened: false,
      value: defaultValue || ""
    }
  },

  componentWillReceiveProps(nextProps){
    if (!(isEqual(nextProps.options, this.state.options) )) {
      this.setState({
        options: nextProps.options,
        value: nextProps.defaultValue || ""
      });
    }
  },

  getValue(){
    return this.state.value
  },

  render(){
    const { options, isOpened, value } = this.state;
    const {
      placeholder,
      name,
      maxlength,
      searchFieldValidationHandler,
      searchFieldValidationMessage
    } = this.props;

    return ( <div className="ui-select-wrap">
      <Box
        isOpened={isOpened}
        value={value}
        onClick={this.openDropdown}
      />
      <Dropdown
        ref={(dropdown) => { this.dropdown = dropdown; }}
        maxlength={maxlength}
        isOpened={isOpened}
        options={options}
        value={value}
        placeholder={placeholder}
        onSelect={this._onSelect}
        onAddItem={this._onAddItem}
        searchFieldValidationHandler={searchFieldValidationHandler}
        searchFieldValidationMessage={searchFieldValidationMessage}
      />
      <input type="hidden" name={name} value={JSON.stringify(value)}/>
    </div> )
  },

  openDropdown(){
    var {isOpened} = this.state;
    this.setState({
      isOpened: !isOpened
    })
  },

  _onSelect(value){
    this.setState({
      value: value,
      isOpened: false
    });

    if (this.props.onSelect) {
      this.props.onSelect(value);
    }
  },

  _onAddItem(value){
    var {options} = this.state;
    options.unshift(value);

    this.setState({
      options: options,
      value: value,
      isOpened: false
    });

    if (this.props.onSelect) {
      this.props.onSelect(value);
    }
  }

});

module.exports = Select;
